import '@caresend/types';
import '@caresend/utils';
import dayjs from 'dayjs';

function displayMinutes(inputMinutes) {
    const minutes = Math.round(inputMinutes);
    if (minutes < 60)
        return `${minutes} min`;
    const mins = Math.floor(minutes % 60);
    const hours = Math.floor(minutes / 60);
    const hrWord = hours > 1 ? 'hours' : 'hour';
    if (mins === 0)
        return `${hours} ${hrWord}`;
    if (mins === 30)
        return `${hours}.5 hours`;
    return `${hours} ${hrWord} ${mins} min`;
}
const formatDate = (date, inputFormat, params = {}) => {
    var _a, _b;
    const { add, noTimezone, yearOptional } = params;
    if (!date)
        return 'Unknown date';
    let formatSuffix = '';
    if (dayjs.tz.guess() !== date.timeZone && !noTimezone) {
        formatSuffix = ' z';
    }
    const currentYear = dayjs().year();
    const isCurrentYear = dayjs(date.timestamp).year() === currentYear;
    let formattedInputFormat = inputFormat;
    if (yearOptional && isCurrentYear) {
        formattedInputFormat = formattedInputFormat
            .replaceAll(', YYYY', '')
            .replaceAll('/YYYY', '');
        formattedInputFormat = formattedInputFormat.replace(/[yY]+/g, '');
    }
    return dayjs.utc(date.timestamp)
        .tz(date.timeZone)
        .add((_a = add === null || add === void 0 ? void 0 : add.duration) !== null && _a !== void 0 ? _a : 0, (_b = add === null || add === void 0 ? void 0 : add.type) !== null && _b !== void 0 ? _b : 'minutes')
        .format(`${formattedInputFormat}${formatSuffix}`);
};
const formatTime = (time, dateFormat, timeFormat) => {
    if (!time)
        return 'Unknown time';
    const formattedDate = dayjs(time.timestamp).tz(time.timeZone).format(dateFormat);
    const formattedTime = dayjs(time.timestamp).tz(time.timeZone).format(timeFormat);
    if (dayjs().isSame(dayjs(time.timestamp), 'day')) {
        return `Today at ${formattedTime}`;
    }
    if (dayjs().subtract(1, 'day').isSame(dayjs(time.timestamp), 'day')) {
        return `Yesterday at ${formattedTime}`;
    }
    if (dayjs().isSame(dayjs(time.timestamp), 'year')) {
        return `${formattedDate} at ${formattedTime}`;
    }
    const formattedYear = dayjs(time.timestamp).tz(time.timeZone).format('YYYY');
    return `${formattedDate}, ${formattedYear} at ${formattedTime}`;
};

export { displayMinutes, formatDate, formatTime };
